import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { selectPceSearchData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import usePceSearchV2 from './usePceSearchV2'

const useRetrievePCEsV2 = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { errorMessage, podSearchDataId } = useSelector(selectPceSearchData)

  const {
    getStreetNumberName,
    getZipCode,
    getInseeCode,
    getCity,
    getOccupant,
    getSerialNumber,
    updateList,
    updatePceConfigData,
  } = usePceSearchV2()

  const searchPCEs = () => {
    const searchParams = {
      streetName: getStreetNumberName,
      zipcode: getZipCode,
      inseeCode: getInseeCode,
      city: getCity,
      occupant: getOccupant,
      serialNumber: getSerialNumber,
    }

    const onSuccess = (results, searchId = null) => {
      updatePceConfigData({ errorMessage: null })
      if (results && Object.keys(results).length > 0) {
        updateList([results]) // there is always one result for PCE search
        updatePceConfigData({ viewPage: 'results', isLoading: false })
      } else if (searchId) {
        updatePceConfigData({ podSearchDataId: searchId })
        // Will be handled by broadcast listener
      }
    }

    const onError = (error) => {
      console.error('❌ PCE Search error:', error)
      updatePceConfigData({
        errorMessage: error || t('subscriptionTools:pce_search.default_error_message'),
        isLoading: false,
        viewPage: 'results'
      })
    }

    updatePceConfigData({ isLoading: true })
    updateList([])

    dispatch({
      type: subscriptionFormActionsV2.PCE_SEARCH_V2,
      searchParams,
      onSuccess,
      onError,
    })
  }

  useEffect(() => {
    if (podSearchDataId === null) {
      return
    }

    window.Echo.channel(`retrieve-search-pod-data.${podSearchDataId}`).listen('.retrieve-search-pod-data', e => {
      if (e.error_message !== null) {
        updatePceConfigData({
          errorMessage: t('subscriptionTools:pce_search.default_error_message'),
          isLoading: false,
          viewPage: 'results'
        })
        console.error(e.error_message)
        return
      }

      if (e.response && Object.keys(e.response).length > 0) {
        updateList([e.response])
      }

      updatePceConfigData({ isLoading: false, viewPage: 'results' })
    })

    return () => {
      window.Echo.leaveChannel(`retrieve-search-pod-data.${podSearchDataId}`)
    }
  }, [podSearchDataId])

  return {
    searchPCEs,
    errorMessage,
  }
}

export default useRetrievePCEsV2
